var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-dialog',{attrs:{"title":"反馈图片","visible":_vm.dialogReport},on:{"update:visible":function($event){_vm.dialogReport=$event}}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.datalist}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }